import contactimg from '../../../../Images/contact.jpg';
import Breadcrumb from '../../../Breadcrumb/Breadcrumb';
import ContactFrom from '../ContactFrom/ContactFrom';
import Contactinfo from '../Contactinfo/Contactinfo';
import GoogleMap from '../GoogleMap/GoogleMap';

const ContactUS = () => {
  return (
    <div>
      <Breadcrumb
        title='Contact Us'
        subTitle='Contact Us'
        slgs='/contact'
        img={contactimg}
      ></Breadcrumb>
      <Contactinfo></Contactinfo>
      <ContactFrom></ContactFrom>
      <GoogleMap mapLink='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d233254.92131755396!2d90.60967376101516!3d24.009610693223475!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3754259764604a2d%3A0xd9ec0ae09bcb6daa!2sNarsingdi%20District!5e0!3m2!1sen!2sbd!4v1766322486550!5m2!1sen!2sbd'></GoogleMap>
    </div>
  );
};

export default ContactUS;
